import styled from 'styled-components';

import { ChevronLeftAlternative, ChevronRightAlternative } from '@/assets/icons';
import { colors, otherColors } from '@/styles/colors';
import { media } from '@/styles/theme';

export { ArrowComponent };

const ArrowComponent = styled.div`
  background-repeat: no-repeat;
  height: 20px;
  width: 12px;

  position: absolute;
  top: 42px;
  cursor: pointer;

  background-color: ${colors.gray.c400};
  mask-repeat: no-repeat;
  mask-position: center center;
  mask-size: contain;

  transition: background-color 0.2s linear, top 0.2s linear;

  &:active {
    transform: translate3d(2px, 2px, 0);
  }

  &:hover {
    background-color: ${otherColors.lxc.blue};
  }

  &[data-disabled='true'] {
    pointer-events: none;
    opacity: 0.3;
  }

  &.left-arrow {
    mask-image: url(${ChevronLeftAlternative});
    left: 10%;
  }
  &.right-arrow {
    mask-image: url(${ChevronRightAlternative});
    right: 10%;
  }

  ${media.tablet} {
    top: 60px;
  }
`;
